<!-- This does NOT work for 'ngSwitch' and is a known issue in Angular 2...don't wrap ngSwitch in 'template'...must be something else:
<ng-template  [ngSwitch]="this.getOption('displayFormat')">
  -->
  <div [ngClass]="{'xct-list-first': isThisTheFirstItemInList(), 'xct-list-last': isThisTheLastItemInList() }" class="collapse-left xct-format-{{ getOption('displayFormat') }}">
    @switch (getOption('displayFormat')) {
      @case ('default') {
        <div class="media">
          <div class="media-left">
            @if (getImageUrl()) {
              <a href="#">
                <img class="media-object" src="{{ getImageUrl() }}" class="xct-img-max-50">
              </a>
            }
          </div>
          <div class="media-body">
            <h4 class="media-heading"><a href="{{ transaction.url }}" class="xct-website-url" target=_blank>{{ transaction.url }}</a>@if (options.isDebug) {
            <span class="xct-debug-text"> [{{ transaction.id }}]</span>
          }</h4>
          <div class="xct-timestamp">{{ transaction.timestamp | date: 'MM/dd/yy HH:mm' }}</div>
          <div class="xct-credits-count"><i class="fa fa-angle-right"></i>{{ this.getCreditsCountText() }}</div>
          @if (options.isDebug) {
            <div class="xct-debug-json">{{ transaction | json }}</div>
          }
        </div>
      </div>
    }
    <!-- This was nice idea, but Angular 2 breaks entirely the notion of having a row as a component. Maybe another day.  -->
    @case ('tableRow3Col') {
      <div class="xct-table-cell">
        <div class="xct-timestamp">{{ transaction.timestamp | date: 'MM/dd/yy HH:mm' }}</div>
      </div>
      <div class="xct-table-cell">
        action {{ transaction.url }}
        @if (options.isDebug) {
          <div class="xct-debug-json">{{ transaction | json }}</div>
        }
      </div>
      <div class="xct-table-cell">
        amount
      </div>
    }
    @default {
      <p>Unidentified 'displayFormat'={{ getOption('displayFormat') }}</p>
    }
  }
</div>

<!--

<div class="xct-table-cell">
  <div class="xct-timestamp">{{ transaction.timestamp | date: 'MM/dd/yy HH:mm' }}</div>
</div>
<div class="xct-table-cell">
  action {{ transaction.url }}
  <div *ngIf="options.isDebug" class="xct-debug-json">{{ transaction | json }}</div>
</div>
<div class="xct-table-cell">
  amount
</div>
</div>

-->
